
namespace RioERP.Enquiry {
    export class EnquiryFollowupColumns {
        static columnsKey = 'Enquiry.EnquiryFollowup';
    }
}